import { LESSON_CURRENCIES, type LessonOfferingDraft } from '../../application/types';

function wholeNumber(value: string): number | null {
  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  return Number(trimmed);
}

export function offeringPayload(draft: LessonOfferingDraft) {
  const title = draft.title.trim();
  const durationMinutes = wholeNumber(draft.durationMinutes);
  const price = wholeNumber(draft.price);
  if (!title || title.length > 255) return null;
  if (durationMinutes == null || durationMinutes < 15 || durationMinutes > 240) return null;
  if (price == null || price > 1_000_000) return null;
  if (!LESSON_CURRENCIES.includes(draft.currency)) return null;
  return {
    title,
    durationMinutes,
    price,
    currency: draft.currency,
  };
}
